import { Routes } from '@angular/router';
import { PageResolveService } from '@features/page/page-resolve.service';
import { PageComponent } from '@features/page/page.component';
import { ProductDetailResolveService } from '@features/product-detail/product-detail-resolve.service';
import { environmentGuard } from '@core/guards/environment.guard';

export const routes: Routes = [
    {
        path: 'styleguide',
        loadChildren: () => import('@features/styleguide/styleguide.module').then(m => m.StyleguideModule),
        canActivate: [environmentGuard]
    },
    {
        path: 'qa-control-panel',
        loadChildren: () =>
            import('@features/qa-control-panel/qa-control-panel.module').then(m => m.QaControlPanelModule),
        canActivate: [environmentGuard]
    },
    {
        path: 'login-redirect',
        loadChildren: () => import('@features/login-redirect/login-redirect.module').then(m => m.LoginRedirectModule)
    },
    {
        path: 'account-verification',
        loadChildren: () => import('@features/login-account/login-account.module').then(m => m.LoginAccountModule)
    },
    {
        path: 'produkt/:name/:id',
        component: PageComponent,
        resolve: {
            content: ProductDetailResolveService
        }
    },
    {
        path: '**',
        component: PageComponent,
        resolve: {
            content: PageResolveService
        }
    }
];
